// extracted by css-extract-rspack-plugin
export default {"title":"LsI9K9fggGES5tbU"};